import React, { Component } from 'react'
import { Form, Field } from 'redux-form'

import { Container } from 'components/Layout'
import Button from 'components/Button'
import SelectPretty from 'components/Input/SelectPretty'
import { Input } from 'components/Input/Input'
import { Textarea } from 'components/Input/Textarea'
import { vRequired } from 'components/Input/Input.validations'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

export default class CasesCreateBillingDisputeModal extends Component {
  onSubmit = formData => {
    const { createBillingDispute, modalConfirm } = this.props
    return createBillingDispute(formData).then(modalConfirm)
  }
  render() {
    const { modalCancel, submitting, handleSubmit, change, bills, invalid } = this.props

    const billOptions = bills.map(bill => ({
      name: `${bill.billNumber} - $${bill.total}`,
      value: bill.billNumber,
    }))

    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center)}>Submit a billing dispute:</div>
          <br />
          <Form onSubmit={handleSubmit(this.onSubmit)}>
            <Field
              label="Bill you dispute"
              name="invoice"
              component={SelectPretty}
              options={billOptions}
              onChangeAlt={billNumber => {
                change('ban', bills.find(bill => bill.billNumber === billNumber).ban)
              }}
              validate={[vRequired]}
            />
            <Field
              label="How much do you dispute?"
              name="disputedAmount"
              component={Input}
              type="number"
              validate={[vRequired]}
            />
            <Field
              label="What do you dispute and why?"
              name="description"
              display="standard"
              component={Textarea}
              validate={[vRequired]}
            />
            <div
              className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
              style={{ marginTop: '40px' }}
            >
              <Button color="tertiary" type="submit" loading={submitting} disabled={submitting || invalid}>
                Submit
              </Button>
              <br />
              <br />
              <Button plain onClick={modalCancel}>
                Cancel
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesCreateBillingDisputeModal/CasesCreateBillingDisputeModal.jsx